import React from 'react';
import { Helmet } from 'react-helmet';

export default function Meta({
  title,
  description,
  canonical,
  og,
  fromWP,
  ogimage,
  isLandingPage,
  ...ogProps
}) {
  // HELPER FUNCS
  function getType(imageURL) {
    return imageURL.includes('.png') ? 'image/png' : 'image/jpeg';
  }

  const ogImage = {
    title: 'Cohort Clinical Sciences',
    url: 'http://store.cohortcs.com/images/og-cohort.jpg',
    secureUrl: 'https://store.cohortcs.com/images/og-cohort.jpg'
  };

  return (
    <Helmet>
      <title>{title || 'Cohort Clinical Science'}</title>
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:image" content={ogImage.url} />
      <meta property="og:image:secure_url" content={ogImage.secureUrl} />
      <meta property="og:image:type" content={getType(ogImage.url)} />
      <meta
        property="og:image:width"
        content="1200"
      />
      <meta
        property="og:image:height"
        content="1200"
      />
      <meta
        property="og:image:alt"
        content={ogImage.title && ogImage.title.replace(/-/g, ' ')}
      />
      <meta property="og:type" content="website" />
      {/* <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@CalibratedUsa" />
      <meta name="twitter:creator" content="@CalibratedUsa" /> */}
    </Helmet>
  );
}
